import { Skeleton } from '@mui/material';

// STYLES
import { Container } from './styles';

const NavItemSkeleton = () => {
  return (
    <Container>
      <Skeleton variant="circular" width={23} height={23} sx={{ bgcolor: 'grey.500' }} />
      <Skeleton height={30} sx={{ bgcolor: 'grey.500' }} />
    </Container>
  );
};

export default NavItemSkeleton;
